import { StyledEditorToolbar } from './styles';

// ----------------------------------------------------------------------

const HEADINGS = ['Heading 1', 'Heading 2', 'Heading 3', 'Heading 4', 'Heading 5', 'Heading 6'];

export const formats = [
  'align',
  'blockquote',
  'bold',
  'bullet',
  'code',
  'code-block',
  'color',
  'direction',
  'font',
  'header',
  'indent',
  'italic',
  'link',
  'list',
  'size',
  'strike',
  'underline',
];

type EditorToolbarProps = {
  id: string;
  simple?: boolean;
  noHeader?: boolean;
};

export default function Toolbar({ id, simple, noHeader, ...other }: EditorToolbarProps) {
  return (
    <StyledEditorToolbar {...other}>
      <div id={id}>
        {noHeader && (
          <div className="ql-formats">
            <select className="ql-header" defaultValue="">
              {HEADINGS.map((heading, index) => (
                <option key={heading} value={index + 1}>
                  {heading}
                </option>
              ))}
              <option value="">Normal</option>
            </select>
          </div>
        )}

        <div className="ql-formats">
          <button type="button" className="ql-bold" />
          <button type="button" className="ql-italic" />
          <button type="button" className="ql-underline" />
          <button type="button" className="ql-strike" />
        </div>

        {!simple && (
          <div className="ql-formats">
            <select className="ql-color" />
          </div>
        )}

        <div className="ql-formats">
          <button type="button" className="ql-list" value="ordered" />
          <button type="button" className="ql-list" value="bullet" />
          {!simple && <button type="button" className="ql-indent" value="-1" />}
          {!simple && <button type="button" className="ql-indent" value="+1" />}
        </div>

        {!simple && (
          <div className="ql-formats">
            <button type="button" className="ql-script" value="super" />
            <button type="button" className="ql-script" value="sub" />
          </div>
        )}

        {!simple && (
          <div className="ql-formats">
            <button type="button" className="ql-code-block" />
            <button type="button" className="ql-blockquote" />
          </div>
        )}

        <div className="ql-formats">
          <button type="button" className="ql-direction" value="rtl" />
          <select className="ql-align" />
        </div>
      </div>
    </StyledEditorToolbar>
  );
}
